import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Icons } from "./../Icons";
import moment from "moment";
import ModalTrazabilidad from "./../ModalTrazabilidad";
import { useNavigate } from "react-router-dom";
import { FlujoAcuerdos, FlujoMontos } from "../../services/PpafeServices";
import { tieneRol } from "../../services/validacionRol";
import { log } from "console";
import { puedeBaja } from "../../utils/permisosFlujo";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  navigate: (path: string) => void; // Agregar navigate como parámetro
}

const getColumnsAcuerdosPF = ({
  handleVerClick,
  urlOrigen,
  navigate, // Recibir navigate como argumento
}: ColumnsProps): GridColDef[] => {

  const flujoDetalle = (accion: "avanzar" | "devolver", id: string) => {
    const tipo = "participaciones";
    const origen = "federales";

    FlujoAcuerdos(tipo, origen, () => { }, () => { }, () => { }, "ELIMINAR", id || "", accion);
  };

  const openSolicitud = (v: any) => {
    const url = `/admin/participaciones/federales/verificacionacuerdospf/` + v;
    navigate(url);
  };
  return [
    {
      field: "acciones",
      headerName: "Acciones",
      headerAlign: "left",
      width: 300,
      sortable: false,
      hideable: false,
      renderCell: (cellValues: any) => {
        const isDisabled = cellValues.row.estatus?.toLowerCase() === "oculto";
        return (
          <Box display="flex" alignItems="center">
            {
              puedeBaja() &&

              <Box sx={{ paddingLeft: "5px" }} ml={2}>
                <Tooltip title="Baja" placement="top">
                  <IconButton onClick={() => flujoDetalle("avanzar", cellValues.row.id)} color="primary" disabled={isDisabled}>
                    {Icons("DeleteForever")}
                  </IconButton>
                </Tooltip>
              </Box>

            }
            <Box sx={{ paddingLeft: "5px" }} ml={2}>
              <Tooltip title="Abrir Registro" placement="top">
                <IconButton onClick={() => {
                  openSolicitud(cellValues.row.id)
                }} color="primary">
                  {Icons("Description")}
                </IconButton>
              </Tooltip>
            </Box>


            <Box sx={{ paddingLeft: "5px" }} ml={1}>
              <ModalTrazabilidad uuid={cellValues.row.id} urlOrigen={urlOrigen} />
            </Box>
            <Box sx={{ paddingLeft: "5px" }} ml={2}>
              <Tooltip title="Semaforización" placement="bottom">
                {/* Ejemplo de otro icono con onClick */}
                <IconButton color="primary">
                  {Icons("CheckCircle")}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        );
      },
    },
    {
      field: "titulo",
      headerName: "Titulo del Documento",
      width: 800,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value}>
            {cellValues.value}
          </Tooltip>
        );
      },
    },
    {
      field: "tipo_publicacion",
      headerName: "Tipo de Publicación",
      width: 200,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value}>
            {cellValues.value}
          </Tooltip>
        );
      },
    },
    {
      field: "fecha",
      headerName: "Fecha",
      width: 200,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const fechaFormateada = moment.utc(cellValues.value).format("DD/MM/YYYY");
        return (
          <Tooltip title={fechaFormateada}>
            <span>{fechaFormateada}</span>
          </Tooltip>
        );
      }
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 100,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const estatus = cellValues.row.estatus?.toLowerCase() === "oculto" ? "BAJA" : cellValues.row.estatus;
        return (
          <Tooltip title={estatus}>
            <span>{estatus}</span>
          </Tooltip>
        );
      }
    },

  ];
};

export default getColumnsAcuerdosPF;
